/**
 * This is a simple pagination implementation meant to be use with `Pagination`
 * component. This is enough for our initial use case
 */

const getInitialPaginationPageItem = (page, index) =>
  index === 0
    ? { page, isActive: true }
    : { page: page + index, isActive: false };

const getLastPaginationPageItem = (page, index) => {
  if (page === 2 && index === 1) {
    return { page, isActive: true };
  }

  if (index === 1) {
    return { page: page - index, isActive: false };
  }

  if (index === 2) {
    return { page, isActive: true };
  }

  if (page === 2 && index === 0) {
    return { page: page - index - 1, isActive: false };
  }

  return { page: page - index - 2, isActive: false };
};

const getDefaultPaginationPageItem = (page, index) =>
  index === 1
    ? { page, isActive: true }
    : {
        page: index < 1 ? page - 1 : page + 1,
        isActive: false,
      };

const usePagination = ({ page = 1, total = 1000, itemsBoundary = 3 }) => {
  const items = Array.from({ length: total < 3 ? 1 : itemsBoundary }).map(
    (_, index) => {
      if (page === 1) {
        return getInitialPaginationPageItem(page, index);
      }

      if (page === total) {
        return getLastPaginationPageItem(page, index);
      }

      return getDefaultPaginationPageItem(page, index);
    }
  );

  return { items };
};

export default usePagination;
